export default "__VITE_ASSET__cf8ad519__"